var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopyToClipboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "content_paste_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4666",
    "data-name": "Pfad 4666",
    d: "M15,1.455H10.88A2.027,2.027,0,0,0,9,0,2.027,2.027,0,0,0,7.12,1.455H3V16H15Zm-6,0a.7.7,0,0,1,.667.727.669.669,0,1,1-1.333,0A.7.7,0,0,1,9,1.455Zm4.667,13.091H4.333V2.909H5.667V5.091h6.667V2.909h1.333Z",
    transform: "translate(0)",
    fill: "#006b87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyToClipboard);
export default __webpack_public_path__ + "static/media/Icon_CopyToClipboard.14d16891870ae8ddcc9f9ab582cd93ea.svg";
export { ForwardRef as ReactComponent };